module.exports = __webpack_public_path__ + "img/Monte_Kope_69.a3cdd416.jpg";